
export const seatsList = [
    { title: 'Seats', seats: 1 }, 
    { title: 'Seats', seats: 2 }, 
    { title: 'Seats', seats: 3 }, 
    { title: 'Seats', seats: 4 }, 
    { title: 'Seats', seats: 5 }, 
    { title: 'Seats', seats: 6 }, 
    { title: 'Seats', seats: 7 }, 
    { title: 'Seats', seats: 8 }, 
    { title: 'Seats', seats: 9 }, 
    { title: 'Seats', seats: 10 }, 
    { title: 'Seats', seats: 11 }, 
    { title: 'Seats', seats: 12 }, 
    { title: 'Seats', seats: 13 }, 
    { title: 'Seats', seats: 14 }, 
    { title: 'Seats', seats: 15 }, 
    { title: 'Seats', seats: 16 }, 
    { title: 'Seats', seats: 17 }, 
    { title: 'Seats', seats: 18 }, 
    { title: 'Seats', seats: 19 }, 
    { title: 'Seats', seats: 20 }, 
    { title: 'Seats', seats: 21 }, 
    { title: 'Seats', seats: 22 }, 
    { title: 'Seats', seats: 23 }, 
    { title: 'Seats', seats: 24 }, 
    { title: 'Seats', seats: 25 }, 
    { title: 'Seats', seats: 26 }, 
    { title: 'Seats', seats: 27 }, 
    { title: 'Seats', seats: 28 }, 
    { title: 'Seats', seats: 29 }, 
    { title: 'Seats', seats: 30 }, 
];

export const statusList = [
    { title: 'Active', status: 'active' }, 
    { title: 'Test', status: 'test' }, 
    { title: 'Inactive', status: 'inactive' },
    { title: 'Suspended', status: 'suspended' }
];